
import React, { useEffect, useState, ReactNode } from 'react';
import Keycloak, { KeycloakProfile } from 'keycloak-js';
import { AuthContext } from './AuthContext';
import { Session } from '../../peer-colab-model/Session';

// Keycloak instance as a module-level singleton
const keycloakInstance = new Keycloak({
  url: 'https://auth.backoffice.petkey.no/auth',
  realm: 'backoffice',
  clientId: 'frontendApp',
});

// ...existing code...

// ...existing code...


// Track Keycloak initialization to prevent double init in dev/HMR
let keycloakInitialized = false;

export const KeycloakProvider = ({ children }: { children: ReactNode }) => {
  const [initialized, setInitialized] = useState(false);
  const [authenticated, setAuthenticated] = useState(false);
  const [profile, setProfile] = useState<KeycloakProfile | null>(null);

  Session.setAuthInfo({
    isAuthenticated: () => authenticated,
    getToken: async () => {
      if (!authenticated)
        return undefined
      await keycloakInstance.updateToken(30)
      return keycloakInstance.token
    }
  })

  useEffect(() => {
    if (!keycloakInitialized) {
      keycloakInitialized = true;
      keycloakInstance.init({ 
        onLoad: 'login-required',
        pkceMethod: 'S256',
        scope: 'openid profile email'
      })
        .then((auth: boolean) => {
          setInitialized(true);
          setAuthenticated(auth);
          if (auth) {
            keycloakInstance.loadUserProfile().then(setProfile);
            /* Later we'll do this ->
            keycloakInstance.loadUserProfile().then(async () => {
              const result = await Session.getClient().request(Bootstrapping.getAppBoostrapInfo())
              if (result.success) {
                setProfile(result.value)
              }
            });
            */
          }
        })
        .catch(() => {
          setInitialized(true);
          setAuthenticated(false);
        });
      // Optionally handle token refresh here
    }
  }, []);

  const login = () => keycloakInstance.login();
  const logout = () => keycloakInstance.logout();

  let content: React.ReactNode = null;
  if (!initialized) {
    content = <div>Loading authentication...</div>;
  } else if (!authenticated) {
    content = <div>Authentication failed. Please try again later.</div>;
  } else {
    content = children;
  }

  return (
    <AuthContext.Provider value={{
      keycloak: keycloakInstance,
      initialized,
      authenticated,
      profile,
      login,
      logout
    }}>
      {content}
    </AuthContext.Provider>
  );
};
